import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { SwiperConfigInterface, SwiperDirective } from 'ngx-swiper-wrapper';
import { Data, AppService } from '../../../app.service';
import { Product } from "../../../app.models";
import { emailValidator } from '../../../theme/utils/app-validators';
import { ProductZoomComponent } from './product-zoom/product-zoom.component';
import { AuthenticationService } from 'src/app/shared/services/authentication.service';
import { ProductModel } from 'src/app/interfaces/product/Product';
import { EnvironmentUrlService } from 'src/app/_services/environment-url.service';


@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.scss']
})
export class ProductComponent implements OnInit {

  public tools: object = {
    items: []
  };
  public videos: any = [];
  currentIndex = 0;
  api;
  currentItem: any;

  @ViewChild('zoomViewer', { static: true }) zoomViewer;
  @ViewChild(SwiperDirective, { static: true }) directiveRef: SwiperDirective;
  public config: SwiperConfigInterface = {};
  public product: Product;
  public image: any;
  public zoomImage: any;
  private sub: any;
  public form: FormGroup;
  public relatedProducts: Array<Product>;
  public manuals: any = [];
  public trainings: any = [];

  constructor(public appService: AppService, private activatedRoute: ActivatedRoute,
    public dialog: MatDialog, public formBuilder: FormBuilder,
    private authService: AuthenticationService,
    public url: EnvironmentUrlService) {

  }

  ngOnInit() {
    this.sub = this.activatedRoute.params.subscribe(params => {
      this.getProductById(params['id']);
      this.getServiceManualByProductById(params['id']);
      this.getTrainingByProductById(params['id']);
      this.getVideosByProductId(params['id']);
    });
    this.form = this.formBuilder.group({
      'review': [null, Validators.required],
      'name': [null, Validators.compose([Validators.required, Validators.minLength(4)])],
      'email': [null, Validators.compose([Validators.required, emailValidator])]
    });
    // this.getRelatedProducts();

  }

  ngAfterViewInit() {
    this.config = {
      observer: false,
      slidesPerView: 4,
      spaceBetween: 10,
      keyboard: true,
      navigation: true,
      pagination: false,
      loop: false,
      preloadImages: false,
      lazy: true,
      breakpoints: {
        480: {
          slidesPerView: 2
        },
        600: {
          slidesPerView: 3,
        }
      }
    }
  }

  public getProductById(id) {
    this.appService.getProductById("/api/Product/GetProductById/" + id,).subscribe(data => {
      this.product = data;
      this.image = data.productImages[0].imageUrl;
      this.zoomImage = data.productImages[0].imageUrl;
      setTimeout(() => {
        this.config.observer = true;
      });
    });
  }
  public getTrainingByProductById(id) {
    this.appService.getTrainingByProductId("api/ProductServiceManual/GetTrainingServicesByProductId/" + id).subscribe(data => {
      this.trainings = data;
    })
  }
  public getServiceManualByProductById(id) {
    this.appService.getServiceCatalogueById("api/ProductServiceManual/GetServicesPartsByProductId/" + id).subscribe(data => {
      this.manuals = data;
    })
  }

  public getRelatedProducts() {
    this.appService.getProducts('related').subscribe(data => {
    })
  }
  public selectImage(productImage) {

    this.image = productImage.imageUrl;
    this.zoomImage = productImage.imageUrl;
  }

  public onMouseMove(e) {
    if (window.innerWidth >= 1280) {
      var image, offsetX, offsetY, x, y, zoomer;
      image = e.currentTarget;
      offsetX = e.offsetX;
      offsetY = e.offsetY;
      x = offsetX / image.offsetWidth * 100;
      y = offsetY / image.offsetHeight * 100;
      zoomer = this.zoomViewer.nativeElement.children[0];
      if (zoomer) {
        zoomer.style.backgroundPosition = x + '% ' + y + '%';
        zoomer.style.display = "block";
        zoomer.style.height = image.height + 'px';
        zoomer.style.width = image.width + 'px';
      }
    }
  }

  public onMouseLeave(event) {
    this.zoomViewer.nativeElement.children[0].style.display = "none";
  }

  public openZoomViewer() {
    this.dialog.open(ProductZoomComponent, {
      data: this.zoomImage,
      panelClass: 'zoom-dialog'
    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  public onSubmit(values: Object): void {
    if (this.form.valid) {
      //email sent
    }
  }

  //embeded video player code

  public getVideosByProductId(id) {
    this.appService.getAllVideos("api/ProductPhotoVideo/GetVideoByProductId/" + id).subscribe(data => {

      this.videos = data;
      this.currentItem = this.videos[this.currentIndex];
    })
  }

  onPlayerReady(api) {

    this.api = api;
    this.api.getDefaultMedia().subscriptions.loadedMetadata.subscribe(this.playVideo.bind(this));
    this.api.getDefaultMedia().subscriptions.ended.subscribe(this.nextVideo.bind(this));

  }

  nextVideo() {
    this.currentIndex++;
    if (this.currentIndex === this.videos.length) {
      this.currentIndex = 0;
    }
    this.currentItem = this.videos[this.currentIndex];

  }


  playVideo() {

    //this.api.play();
  }

  onClickPlaylistItem(item, index: number) {
    this.currentIndex = index;
    this.currentItem = item;


  }

  // onStateChange(event) {
  //   this.ytEvent = event.data;
  // }
  // savePlayer(player) {
  //   this.player = player;
  // }

  // playVideo() {
  //   this.player.playVideo();
  // }

  // pauseVideo() {
  //   this.player.pauseVideo();
  // }
}